<mat-card class="mb-0">
    <mat-card-content>
      <h3 class="info-title">{{title}}</h3>

      <div *ngIf="links && links.length" class="operations">
        <div *ngFor="let link of links" class="operation">
          <img *ngIf="link.icon" [src]="link.icon" class="square-icon operation-icon"/>
          <div *ngIf="link.text" class="text">{{link.text}}</div>
          <a *ngIf="link.link" [href]="link.link" [target]="link.linkTarget ?? '_self'">
            <div class="text" [innerHTML]="link.linkText | sanitizedHtml"></div>
          </a>
        </div>
      </div>
  
      <div *ngIf="more" class="text-center mt-2">
        <button mat-stroked-button color="primary" class="w-phone-100">לכל הפעולות באיזור האישי</button>
      </div>
    </mat-card-content>
  </mat-card>